<template>
  <v-container fluid>
    <v-card>
      <v-toolbar>
        <v-icon>post_add</v-icon>
        <v-toolbar-title class="font-weight-light"
          >Manejo de Comprobantes Fiscales</v-toolbar-title
        >
        <v-spacer></v-spacer>
        Documento {{ selectedPersonaDocumento }}
        <v-tooltip bottom>
          <template v-slot:activator="{ on }">
            <v-btn
              text
              icon
              color="red"
              v-on="on"
              @click="setStatusTareaFrecuente(action)"
            >
              <v-icon v-if="action.esFrecuente">favorite</v-icon>
              <v-icon v-else>favorite_border</v-icon>
            </v-btn>
          </template>
          <span v-if="action.esFrecuente">Quitar de Tareas Frecuentes</span>
          <span v-else>Agregar a Tareas Frecuentes</span>
        </v-tooltip>
      </v-toolbar>
      <v-card-text>
        <v-row>
          <v-col cols="3">
            <v-autocomplete
              v-model="filtro.empresaId"
              :items="empresas"
              autocomplete="disabled"
              item-text="nombre"
              item-value="id"
              label="De la Empresa:"
              placeholder="Seleccione una"
            ></v-autocomplete>
          </v-col>
          <v-col cols="3">
            <v-autocomplete
              v-model="filtro.sucursalId"
              :items="sucursales"
              item-text="nombre"
              item-value="id"
              label="Originadas en:"
              placeholder="Seleccione una"
            ></v-autocomplete>
          </v-col>
          <v-col cols="3">
            <v-autocomplete
              v-model="filtro.tipoComprobanteId"
              :items="listTiposComprobante"
              item-text="descripcion"
              item-value="id"
              label="Tipo:"
              placeholder="Seleccione uno"
            ></v-autocomplete>
          </v-col>
          <v-col cols="3">
            <app-selector-periodos
              v-on:update-periodo="filtro.periodo = $event"
              :column="true"
            ></app-selector-periodos>
          </v-col>
        </v-row>
        <v-row align="center">
          <v-col cols="3">
            <v-text-field
              v-model="filtro.cui"
              label="Buscar por documento/cuil"
            ></v-text-field>
          </v-col>

          <v-col cols="3">
            <v-checkbox
              v-model="filtro.soloPendientesAutorizacion"
              label="Sólo pendientes de autorizar por AFIP"
            ></v-checkbox>
          </v-col>
          <v-spacer></v-spacer>
          <v-col cols="3">
            <v-btn color="success" @click="getItems(true)">Traer Casos</v-btn>
          </v-col>
        </v-row>

        <v-flex>
          <v-card>
            <v-toolbar :color="$store.state.UiColors.crudToolbarList">
              <v-icon>list</v-icon>
              <v-toolbar-title class="font-weight-light">Lista</v-toolbar-title>

              <v-spacer></v-spacer>
              <v-switch
                v-model="accionesMasivas"
                label="Acciones Masiva"
              ></v-switch>
            </v-toolbar>

            <v-data-table
              dense
              :headers="headers"
              :items="records"
              :server-items-length="totalItems"
              :rows-per-page="pagination.rowsPerPage"
              :options.sync="pagination"
              v-model="selectedRow"
              :loading="loading"
              class="elevation-1"
              :footer-props="footer"
              item-key="id"
              :show-select="records.length > 0 && accionesMasivas"
            >
              <template v-slot:no-data>
                <v-alert
                  v-if="!primeraBusquedaRealizada"
                  :value="true"
                  color="grey lighten-3"
                  icon="info"
                >
                  Ingrese los filtros para realizar la búsqueda
                </v-alert>
                <v-alert v-else :value="true" color="grey" icon="warning">
                  No se encontraron datos
                </v-alert>
              </template>

              <template v-slot:item="{ item, isSelected, select }">
                <!-- <tr v-for="item in items" :key="item.id" @click="selectRow(item)" :class="{'selectedRow': item === selectedRow[0]}"> -->
                <tr
                  :key="item.id"
                  @click="selectRow(item)"
                  :class="{
                    selectedRow: item === selectedRow[0] && !accionesMasivas,
                  }"
                >
                  <td v-if="accionesMasivas == true">
                    <v-simple-checkbox
                      class="caption"
                      color="green"
                      :value="isSelected"
                      @input="select($event)"
                    ></v-simple-checkbox>
                  </td>

                  <td>
                    <app-acciones-comunes
                      :personaId="item.personaId"
                      :documento="item.personaCui.substring(2, 10)"
                    >
                    </app-acciones-comunes>
                  </td>

                  <td class="text-xs-left caption">{{ item.tipo }}</td>
                  <td class="text-xs-left caption">{{ item.origen }}</td>
                  <td class="text-xs-left caption">{{ item.numero }}</td>
                  <td class="text-xs-left caption">
                    {{
                      item.fecha
                        | dateParse('YYYY-MM-DD')
                        | dateFormat('DD-MM-YYYY')
                    }}
                  </td>
                  <td class="text-xs-left caption">
                    {{ item.importe | currency }}
                  </td>
                  <td class="text-xs-left caption">{{ item.personaNombre }}</td>
                  <td class="text-xs-left caption">{{ item.personaCui }}</td>
                  <td class="text-xs-left caption">{{ item.comentarios }}</td>
                  <td class="text-xs-left caption">{{ item.estado }}</td>
                  <td class="text-xs-left caption">
                    <v-chip small :color="item.empresaColor" label dark>{{
                      item.empresaShort
                    }}</v-chip>
                  </td>
                </tr>
              </template>
            </v-data-table>
          </v-card>
        </v-flex>

        <v-divider></v-divider>
      </v-card-text>
      <v-card-actions>
        <v-container fluid>
          <v-row dense>
            <v-col>
              <v-btn
                v-if="
                  selectedRow.length > 0 &&
                    selectedRow[0].estado === 'Aut. Pendiente'
                "
                @click.stop="solicitarAutorizacionAfip()"
                color="brown"
                dark
              >
                Solicitar Autorización AFIP</v-btn
              >
              &nbsp;
              <!-- <v-btn v-if="selectedRow.length>0 && selectedRow[0].estado != 'Anulada'" @click.stop="anular()" color="red" dark> Anular</v-btn>&nbsp; -->
              <v-btn
                v-if="selectedRow.length > 0"
                @click.stop="imprimir()"
                color="blue"
                dark
              >
                Imprimir &nbsp;<v-icon>print</v-icon></v-btn
              >&nbsp;
            </v-col>
          </v-row>

          <v-row dense>
            <v-col>
              <v-btn @click.stop="altaFactura()" color="brown" dark>
                Dar de Alta una Factura</v-btn
              >
              &nbsp;
              <v-btn @click.stop="altaNotaCredito()" color="indigo" dark>
                Dar de Alta una Nota de Crédito</v-btn
              >
              &nbsp;
              <v-btn @click.stop="altaNotaDebito()" color="pink" dark>
                Dar de Alta una Nota de Débito</v-btn
              >
            </v-col>
          </v-row>
        </v-container>
      </v-card-actions>
    </v-card>

    <!-- Resultados Autorizacion Afip  -->
    <v-dialog v-model="showResultadosAutorizacion" width="1000">
      <v-card :dark="$store.state.UiCustomUserSettings.temaOscuro">
        <v-card-title class="headline">Resultados Autorización</v-card-title>
        <v-card-text>
          <v-layout wrap>
            <v-list>
              <v-list-item v-for="item in resultadosAutorizacion" :key="item">
                <template>
                  {{ item }}
                </template>
              </v-list-item>
            </v-list>
          </v-layout>
        </v-card-text>
      </v-card>
    </v-dialog>

    <!-- Ver Legajo Cliente  -->
    <v-dialog v-model="showLegajoPersona" width="1000">
      <legajo-persona :personaId="selectedPersonaId"> </legajo-persona>
    </v-dialog>

    <!-- Ver Legajo Virtual  -->
    <v-dialog v-model="showLegajoVirtual" persistent width="700">
      <legajo-virtual
        :documento="selectedPersonaDocumento"
        @close-dialog="showLegajoVirtual = false"
      >
      </legajo-virtual>
    </v-dialog>

    <v-dialog v-model="showReport" width="700">
      <reportes-test
        :reporte="reporteAMostrar"
        :params="reportParams"
        @close-dialog="showReport = false"
      >
      </reportes-test>
    </v-dialog>

    <app-loading :loading="componentsLoading || autorizando"></app-loading>

    <template v-if="$store.state.debugModeOn">
      Debug Info:
      <p></p>

      Model: {{ filtro }}
      <p></p>
      {{ selectedRow }}
      <p></p>
    </template>
  </v-container>
</template>

<style scoped>
.selectedRow {
  background-color: greenyellow;
  font-weight: bold;
}
</style>

<script>
import { http } from '@/axios';
import Vue from 'vue';
import {
  //mapState,
  mapGetters,
  mapMutations,
  mapActions,
} from 'vuex';

import LegajoPersona from '@/components/legajo/layout.vue';
import LegajoVirtual from '@/components/legajo/legajoVirtual.vue';

export default {
  components: {
    'legajo-persona': LegajoPersona,
    'legajo-virtual': LegajoVirtual,
  },
  data() {
    return {
      primeraBusquedaRealizada: false,
      loading: false,
      suspend: false,
      filterChanged: false,
      search: '', // valor para búsqueda
      pagination: {
        // definición de paginación
        sortDesc: [true],
        sortBy: [''],
        page: 1,
        itemsPerPage: 5,
      },
      footer: {
        showFirstLastPage: true,
        itemsPerPageOptions: [10, 20, 50, 100, 500, 1000],
      },
      totalItems: 0, // va afuera de pagination
      headers: [
        // definición de columnas
        { text: 'Ver', value: 'accion', width: 80, sortable: false },
        { text: 'Tipo', value: 'tipo' },
        { text: 'Origen', value: 'origen' },
        { text: 'Numero', value: 'numero' },
        { text: 'Fecha', value: 'fecha', width: 130 },
        { text: 'Importe', value: 'importe', width: 130 },
        { text: 'Se hizo a', value: 'personaNombre' },
        { text: 'Cuil', value: 'personaCui' },
        { text: 'Comentarios', value: 'comentarios' },
        { text: 'Estado', value: 'estado' },
        { text: 'Empresa', value: 'empresa' },
      ],
      records: [], // registros
      selectedRow: [],
      filtro: {
        empresaId: 0,
        sucursalId: 0,
        tipoComprobanteId: 0,
        cui: 0,
        periodo: { id: 1 },
        soloPendientesAutorizacion: false,
      },
      //selectedCaso: {creditosEnMora:[],telefonos:[],otrasGestiones:[]},
      empresas: [],
      sucursales: [],
      listTiposComprobante: [],
      showDetalle: false,
      showLegajoPersona: false,
      showLegajoVirtual: false,
      selectedPersonaId: '',
      selectedTareaAsignadaId: '',
      selectedPersonaDocumento: '',
      selectedPersona: {},
      showReport: false,
      reportParams: [],
      reporteAMostrar: '',
      accionesMasivas: false,
      showResultadosAutorizacion: false,
      resultadosAutorizacion: [],
      autorizando: false,
    };
  },
  async created() {
    this.loadEmpresas();
    this.loadSucursales();
    this.loadTiposComprobante();
  },
  watch: {
    pagination: {
      handler() {
        if (this.primeraBusquedaRealizada) this.getItems(false);
      },
      deep: true,
    },
    accionesMasivas: {
      handler() {
        if (!this.accionesMasivas) this.selectedRow = [];
      },
    },
    search() {
      this.getItems(true);
    },
    activeTask: function() {
      //closeRelatedTasks es una variable del state que la pongo en true cuando se cierra el coso de activeTask y quiero cerrar otras cosas relacionadas
      if (this.closeRelatedTasks) {
        this.showDetalle = false;
        this.getItems(false);
      }
    },
  },
  computed: {
    ...mapGetters([
      'activeTask',
      'getActionFromLink',
      'user',
      'closeRelatedTasks',
    ]),
    action: function() {
      return this.getActionFromLink(this.$route.path);
    },
    componentsLoading: function() {
      return (
        this.loadingCreditosEnMora ||
        this.loadingTelefonos ||
        this.loadingGestionesTelefonicas ||
        this.loadingOtrasGestiones
      );
    },
  },
  methods: {
    ...mapMutations([
      'setActiveTask',
      'alertClear',
      'alertSuccess',
      'alertWarning',
      'alertError',
      'setReporteActivo',
    ]),
    ...mapActions(['setStatusTareaFrecuente']),

    selectRow(item) {
      if (this.selectedRow[0] === item) {
        this.selectedRow.pop();
      } else {
        this.selectedRow.pop();
        this.selectedRow.push(item);
      }
    },
    async getItems(resetPagination) {
      //Hago esto para que si cambias los filtros y tocas consultar traiga los resultados de la primera página
      if (resetPagination) {
        this.pagination.page = 1;
      }

      this.loading = true;
      this.$validator.reset();

      let filter = this.filtro;

      filter.cui = filter.cui ? filter.cui : 0;

      let incluirNotasCredito =
        filter.tipoComprobanteId == 0 || filter.tipoComprobanteId == 1;
      let incluirNotasDebito =
        filter.tipoComprobanteId == 0 || filter.tipoComprobanteId == 2;
      let incluirFacturasVenta =
        filter.tipoComprobanteId == 0 || filter.tipoComprobanteId == 3;

      try {
        var result = await http.get(
          'comprobantes/listcomprobantesfiscales?empresaId=' +
            filter.empresaId +
            '&sucursalId=' +
            filter.sucursalId +
            '&incluirNotasCredito=' +
            incluirNotasCredito +
            '&incluirNotasDebito=' +
            incluirNotasDebito +
            '&incluirFacturasVenta=' +
            incluirFacturasVenta +
            '&fechaDesde=' +
            filter.periodo.desde +
            '&fechaHasta=' +
            filter.periodo.hasta +
            '&soloPendientesAutorizacion=' +
            filter.soloPendientesAutorizacion +
            '&documento=' +
            filter.cui +
            '&limit=' +
            this.pagination.itemsPerPage +
            '&page=' +
            this.pagination.page +
            '&sortby=' +
            this.pagination.sortBy +
            '&descending=' +
            (this.pagination.sortDesc.length > 0
              ? this.pagination.sortDesc
              : 'false')
        );

        Vue.$log.debug(result);

        this.records = result.list;

        this.totalItems = result.totalCount;
      } catch (error) {
        // Error
        this.alertError(error);
      }
      this.primeraBusquedaRealizada = true;
      this.loading = false;

      if (this.selectedRow.length > 0) {
        this.selectedRow.pop();
      }
    },
    async getDetalleCaso(caso) {
      this.selectedPersonaId = caso.personaId;
      //hago esto para que no busque el detalle cuando se toca para ver los legajos. los cosos se buscan cuando se hace el loadPersona
      if (this.showLegajoPersona || this.showLegajoVirtual) return;

      this.selectedRow[0] = caso;

      this.selectedTareaAsignadaId = caso.tareaId;
      this.loadPersona(caso.personaId);

      this.showDetalle = true;
    },
    async loadPersona(personaId) {
      this.loading = true;
      try {
        var result = await http.get('personas/' + personaId);

        this.selectedPersona = result;

        // trato las fechas
        var dob = this.$moment(this.selectedPersona.fechaNacimiento).format(
          'YYYY-MM-DD'
        );
        this.selectedPersona.fechaNacimiento = dob;

        if (this.selectedPersona.empleo != null) {
          var fi = this.$moment(
            this.selectedPersona.empleo.fechaIngreso
          ).format('YYYY-MM-DD');
          this.selectedPersona.empleo.fechaIngreso = fi;
        }
      } catch (error) {
        // Error
        this.alertError(error);
      }
      this.loading = false;
    },
    async verLegajo(item) {
      this.selectedPersonaId = item.personaId;
      this.showLegajoPersona = true;
    },
    async verLegajoVirtual(item) {
      alert(JSON.stringify(item));
      this.selectedPersonaDocumento = item.documento.toString();
      this.showLegajoVirtual = true;
    },
    async verContactos(item) {
      this.selectedPersonaId = item.personaId;
      this.showListaCreditos = true;

      var params = {
        width: 700,
        visible: true,
        personaId: item.personaId,
      };

      this.setActiveTask({ task: 'app-log-contactos', props: params });
    },
    async verCreditos(item) {
      this.selectedPersonaId = item.personaId;

      var params = {
        width: 900,
        visible: true,
        personaId: item.personaId,
      };

      this.setActiveTask({ task: 'app-lista-creditos', props: params });
    },
    async loadEmpresas() {
      this.loading = true;
      try {
        var result = await http.get(
          'empresas/list/porusuario?usuarioId=' + this.user.id
        );

        this.empresas = result.list;
        this.empresas.unshift({ id: 0, nombre: '(Todas)' });
      } catch (error) {
        // Error
        this.alertError(error);
      }
      this.loading = false;
    },
    async loadSucursales() {
      this.loading = true;
      try {
        var result = await http.get(
          'sucursales/list/porusuario?usuarioId=' + this.user.id
        );

        this.sucursales = result.list;

        this.sucursales.unshift({ id: 0, nombre: '(Todas)' });
      } catch (error) {
        // Error
        this.alertError(error);
      }
      this.loading = false;
    },
    async loadTiposComprobante() {
      this.listTiposComprobante.push({ id: 0, descripcion: '(Todos)' });
      this.listTiposComprobante.push({
        id: 1,
        descripcion: 'Notas de Crédito',
      });
      this.listTiposComprobante.push({ id: 2, descripcion: 'Notas de Débito' });
      this.listTiposComprobante.push({
        id: 3,
        descripcion: 'Facturas de Venta',
      });
    },
    altaNotaCredito() {
      var params = {
        width: 900,
        visible: true,
      };

      this.setActiveTask({
        task: 'app-alta-notas-credito-fiscales',
        props: params,
      });
    },
    altaNotaDebito() {
      var params = {
        width: 900,
        visible: true,
        modo: 'NotasDebito',
      };

      this.setActiveTask({
        task: 'app-alta-notas-debito-fiscales',
        props: params,
      });
    },
    altaFactura() {
      var params = {
        width: 900,
        visible: true,
        modo: 'Facturas',
      };

      this.setActiveTask({
        task: 'app-alta-notas-debito-fiscales',
        props: params,
      });
    },
    async solicitarAutorizacionAfip() {
      if (this.selectedRow.length === 0) {
        this.alertWarning(
          'Debe elegir un comprobante para solicitar la autorización.'
        );
        return;
      }

      // var comprobante = this.selectedRow[0];

      // var tipoComprobante = '';

      // if(comprobante.tipo === 'Nota Débito')
      //   tipoComprobante = 'NotaDebitoFiscal';
      // else if(comprobante.tipo === 'Nota Crédito')
      //   tipoComprobante = 'NotaCreditoFiscal';
      // else if(comprobante.tipo === 'Factura Venta')
      //   tipoComprobante = 'Factura';

      try {
        this.autorizando = true;

        var listaComprobantes = [];
        for (let i = 0; i < this.selectedRow.length; i++) {
          const comprobante = this.selectedRow[i];

          listaComprobantes.push({
            id: comprobante.id,
            tipo: comprobante.tipo,
          });
        }

        this.resultadosAutorizacion = [];

        for (let i = 0; i < listaComprobantes.length; i++) {
          const comprobante = listaComprobantes[i];

          var res = await http.post(
            'comprobantes/autorizarcomprobantefiscal',
            JSON.stringify({
              comprobanteId: comprobante.id,
              tipo: comprobante.tipo,
            })
          );

          //console.log(res)

          if (res.autorizado) {
            this.resultadosAutorizacion.push(
              res.comprobanteDescripcion +
                ': Autorizado con Número' +
                res.numero
            );
          } else {
            this.resultadosAutorizacion.push(
              res.comprobanteDescripcion + ': ' + res.errores
            );
          }
        }

        this.getItems(false);
        this.showResultadosAutorizacion = true;
        this.autorizando = false;
      } catch (error) {
        this.showResultadosAutorizacion = true;
        this.autorizando = false;
        // Error
        this.alertError(error);
      }
    },
    imprimir() {
      let params = [];

      var listaIds = '';

      for (let i = 0; i < this.selectedRow.length; i++) {
        const item = this.selectedRow[i];
        if (listaIds != '') listaIds = listaIds + ',';
        listaIds = listaIds + item.id;
      }

      params.push({
        ListaIds: listaIds,
      });

      this.setReporteActivo({
        reporte: 'ComprobanteVentaElectronico.trdp',
        params: params,
      });
      window.open('/report-viewer');
    },
  },
};
</script>
